import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '../../api';
import { Grid3x3, Check, AlertTriangle, Loader2 } from 'lucide-react';

const AddPasscodeModal = ({ device, person, onClose }) => {
    const [passcode, setPasscode] = useState('');
    const [status, setStatus] = useState('input'); // input | submitting | success | error
    const [errorMessage, setErrorMessage] = useState('');

    const handleSave = async () => {
        if (!passcode || passcode.length < 4) {
            toast.error("Passcode must be 4-8 digits.");
            return;
        }

        setStatus('submitting');
        setErrorMessage('');

        try {
            // Use the person's existing employee_code (User ID on device)
            const payload = {
                userId: person.employee_code,
                name: `${person.first_name} ${person.last_name}`,
                passcode: passcode
            };

            await api.setEmployeePasscode(device.id, payload);
            
            setStatus('success');
            toast.success("Passcode saved successfully!");
            
        } catch (error) {
            console.error("Passcode Error:", error);
            setErrorMessage(error.message || "Failed to save passcode.");
            setStatus('error');
        }
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1100 }}>
            <div className="modal-content text-center" style={{ maxWidth: '400px' }}>
                <div className="modal-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
                        <div style={{ background: '#f1f5f9', padding: '8px', borderRadius: '50%', color: '#334155' }}>
                            <Grid3x3 size={24} />
                        </div>
                        <h2 className="modal-title" style={{ margin: 0 }}>Set Passcode</h2>
                    </div>
                </div>

                <div className="modal-body" style={{ marginTop: '20px' }}>
                    
                    {/* INPUT STATE */}
                    {(status === 'input' || status === 'submitting') && (
                        <>
                            <p style={{ color: '#64748b', fontSize: '0.9em', marginBottom: '20px' }}>
                                Enter a new numeric passcode for <strong>{person.first_name}</strong>.
                            </p>
                            
                            <div className="form-group" style={{ textAlign: 'left' }}>
                                <label className="form-label required">New Passcode</label>
                                <input 
                                    type="text" 
                                    className="form-input" 
                                    value={passcode} 
                                    onChange={(e) => setPasscode(e.target.value.replace(/\D/g, ''))} 
                                    placeholder="Enter 4-8 digits"
                                    maxLength={8}
                                    autoFocus
                                    disabled={status === 'submitting'}
                                />
                            </div>

                            <div className="modal-actions" style={{ marginTop: '20px' }}>
                                <button className="button button-secondary" onClick={onClose} disabled={status === 'submitting'}>Cancel</button>
                                <button className="button action-button" onClick={handleSave} disabled={status === 'submitting' || !passcode}>
                                    {status === 'submitting' ? (
                                        <><Loader2 className="spin" size={16} style={{marginRight:'5px'}}/> Saving...</>
                                    ) : 'Save Passcode'}
                                </button>
                            </div>
                        </>
                    )}

                    {/* SUCCESS STATE */}
                    {status === 'success' && (
                        <div className="text-center">
                            <div style={{ background: '#dcfce7', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px auto', color: '#16a34a' }}>
                                <Check size={32} />
                            </div>
                            <h3 className="text-lg font-bold text-green-600 mb-2">Success!</h3>
                            <p className="text-gray-600 mb-6">Passcode has been updated on the device.</p>
                            <button onClick={onClose} className="button action-button" style={{ width: '100%' }}>Done</button>
                        </div>
                    )}

                    {/* ERROR STATE */}
                    {status === 'error' && (
                        <div className="text-center">
                            <div style={{ background: '#fee2e2', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px auto', color: '#dc2626' }}>
                                <AlertTriangle size={32} />
                            </div>
                            <h3 className="text-lg font-bold text-red-600 mb-2">Failed</h3>
                            <p className="text-gray-600 mb-6">{errorMessage}</p>
                            <div className="modal-actions">
                                <button className="button button-secondary" onClick={onClose}>Close</button>
                                <button className="button action-button" onClick={() => setStatus('input')}>Try Again</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AddPasscodeModal;